// extracted by mini-css-extract-plugin
export var chevron = "_ix-2";
export var dropdownItems = "_ix-0";
export var item = "_ix-1";